import React, { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui';

import { AtlasGqlInspection } from 'types/atlas-graphql';
import { Steps } from '../UploadInspectionDataModal';
import { ButtonContainer, ValidationTable } from '../UploadInspectionDataModal.style';
import { STANDARD_COLUMN_SCROLL_Y } from 'utils/constants';
import { date, status, type, vendor } from 'components/data/inspections';

export type ValidationProps = {
  inspection: AtlasGqlInspection;
  hasNewInspectionTask: boolean;
  setStep: Dispatch<SetStateAction<Steps>>;
  setPendingStep: Dispatch<SetStateAction<Steps>>;
  rollback: {
    update: (toastMessage?: string) => Promise<void>;
    loading: boolean;
  };
};

export const Validation: React.FC<ValidationProps> = ({ inspection, setStep, rollback }) => {
  const { update: _handleRollback, loading: rollbackLoading } = rollback;

  const handleContinue = () => {
    const nextStep = Steps.DetailsUpload;
    setStep(nextStep);
  };

  const handleRollback = async () => {
    await _handleRollback();

    setStep(Steps.SingleUpload);
  };

  return (
    <>
      <p>Inspection successfully created.</p>
      <ValidationTable
        columns={[date, type, vendor, status]}
        dataSource={[inspection]}
        scroll={STANDARD_COLUMN_SCROLL_Y}
      />
      <ButtonContainer>
        <Button type="primary" danger={true} onClick={handleRollback} loading={rollbackLoading}>
          Roll Back Changes
        </Button>
        <Button type="primary" onClick={handleContinue}>
          Continue to Details
        </Button>
      </ButtonContainer>
    </>
  );
};
